module.exports = __webpack_public_path__ + "static/media/data_pipeline.b20a0e47.jpg";